import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faTimes,
  faTimesCircle,
  faCheckCircle,
  faCaretSquareDown,
  faCaretSquareUp,
  faMinus,
  faPlus,
  faCircleXmark,
  faReply,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faBars,
  faMinus,
  faTimes,
  faTimesCircle,
  faCheckCircle,
  faCaretSquareDown,
  faCaretSquareUp,
  faPlus,
  faCircleXmark,
  faReply,
  faHandshake
);
